/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Actions_TitleInputs */



/**
* | output |
* | --- |
* | "Agreements from this conversation" |
*
* @param {Meeting_Report_Actions_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_actions_title = /** @type {((inputs?: Meeting_Report_Actions_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Actions_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Actiepunten uit dit gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Points d'action de cette conversation")
	return /** @type {LocalizedString} */ ("Agreements from this conversation")
});